<template>
  <div>
    <b-row>
      <b-col cols="2">
        <b-img
            v-if="providerImgURL"
            v-bind="mainProps"
            :src="providerImgURL"
            style="object-fit: scale-down"
            alt="Provider image"/>
      </b-col>
      <b-col>
        <h2>{{recipientNickname}}, you’ve been invited to join the the Provider Account of {{providerName}}</h2>
        <h6 v-if="expiration">
          This invitation expires on {{expiration}}
        </h6>
        <h6>Not {{recipientNickname}}? Please ignore this invite.</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3" offset="2">
        <b-img
            src="/assets/img/appwelcome.jpg"
            fluid
            alt="Responsive image"
        />
      </b-col>
      <b-col style="margin-bottom: 15px;">
        <p>
        Welcome aboard to the HeartBeatFam Provider Community!
        We are thrilled to have you join us as a valued member of our platform dedicated to enhancing healthcare
        services through innovative solutions.
        </p>
        <p>
        At HeartBeatFam, we believe in empowering healthcare providers like you to connect with clients in a
        meaningful way, offering your expertise through engaging webinars and delivering top-notch healthcare
        services. Your participation in our community not only enriches the lives of your clients but also
        contributes to the advancement of healthcare as a whole.
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button
            class="btn-add-crew"
            variant="success"
            @click="handleInvitationResponse(true)">
          Join
        </b-button>
      </b-col>
      <b-col>
        <b-button
            class="btn-add-crew"
            variant="danger"
            @click="handleInvitationResponse(false)">
          No
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RecordViews from "@/mixins/RecordViews";
import moment from "moment";
export default {
  name: "Provider_Invite_Notice",
  mixins: [RecordViews],
  components: {},
  props: {
    invitation: {
      type: Object,
      required: true
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      user: "user/user",
      profile:"user/profile"
    }),
    providerName() {
      return this.invitation  && this.invitation.provider && this.invitation.provider.name ?
          this.invitation.provider.name
          : null;
    },
    providerImgURL() {
      return this.invitation  && this.invitation.provider && this.invitation.provider.imgURL ?
          this.invitation.provider.imgURL
          : null;
    },
    recipientNickname() {
      return this.invitation  && this.invitation.rec && this.invitation.rec.nickname ?
          this.invitation.rec.nickname
          : null;
    },
    expiration() {
      return this.invitation  && this.invitation._expire_at ?
          this.formatDate(this.invitation._expire_at)
          : null;
    },
  },
  methods: {
    recordView(publishingId) {
      this.$store.dispatch("listings/recordFeedback", {
        userId: this.user ? this.user.uid : null,
        pathId: "invites",
        entityId: publishingId,
        feedbackType: "views",
        sessionId: this.checkSession("sessions")
      });
    },
    handleInvitationResponse(hasAccepted){
      this.$emit('invitation-response', hasAccepted);
    },
    formatDate(date) {
      return date
          ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
          : "N/A";
    },
  },
  metaInfo() {
    return {
      title: "JourneyBinder Blog",
      meta: [
        // Twitter Card
        { name: "twitter:title", content: this.blogTitle },
        { name: "twitter:card", content: "Our Blog Page" },
        { name: "twitter:description", content: this.description },
        { name: "twitter:image", content: this.logo },
        { property: "og:title", content: this.blogTitle },
        { property: "og:site_name", content: "JourneyBinder" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        { property: "og:description", content: this.description }
      ]
    };
  },
  data() {
    return {
      userHasAccepted: null,
      openForm: false,
      mainProps: { blank: false, width: 150, height: 150, class: 'm1' },
      invitationState:'initial', //initial/rejected/approved
      inviteCode: null,
    };
  },
};
</script>
